import { WebsiteRead } from '@/api/dashboard'
import { getWebsiteUrl } from '@/layouts/websites'

/**
 * This function fetches the processed theme from the server (from next instance).
 * @param website
 * @param theme
 */
export const fetchProcessedTheme = async (
  website: WebsiteRead,
  theme: unknown,
): Promise<{ css: string; json: Record<string, string> }> => {
  const url = getWebsiteUrl({ website, mode: 'api', pathname: '/api/theme-process' })

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({ theme }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  if (!response.ok) {
    throw new Error('Failed to fetch theme data')
  }
  return (await response.json()) as { css: string; json: Record<string, string> }
}
